export default [
  {
    path: '/class-attendances-v2',
    name: 'class-attendance-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/class-attendance-v2/index.vue')
  }
]
